var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"results-row"},[_vm._v(" \""+_vm._s(_vm.result.key)+"\" : "+_vm._s(_vm.result.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }